var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('core-dtwin-finder', {
    attrs: {
      "value": _vm.value,
      "label": _vm.$i18n_t('Common.digitalTwins.searchParentLabel'),
      "placeholder": _vm.$i18n_t('Common.digitalTwins.searchParentPlaceholder'),
      "dense": _vm.dense,
      "hideDetails": ""
    },
    on: {
      "dtwin-selected": _vm.handleTwinSelected
    },
    scopedSlots: _vm._u([{
      key: "append-outer",
      fn: function () {
        return [_c('core-button', {
          staticClass: "rule-add-button",
          attrs: {
            "color": _vm.color,
            "disabled": !_vm.canAddRule,
            "prepend-icon": "fa-plus",
            "data-cy": "button_add_rule"
          },
          on: {
            "click": function ($event) {
              return _vm.$emit('add-rule');
            }
          }
        })];
      },
      proxy: true
    }])
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };